import { Button } from "@mui/material";
import { styled } from "styled-components";

export const CustomButtonContainer = styled(Button)`
  height: 36px;
  align-self: center;
  border: 1px solid ${({ theme }) => theme.colors.buttonBorder} !important;
  color: ${({ theme }) => theme.colors.textColor};
  background-color: ${({ theme }) => theme.name === "light-theme" ? theme.colors.white : theme.colors.buttonBackground};
  border-radius: 2rem !important;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-transform: none;
  
  &:hover {
    border-color: ${({ theme }) => theme.colors.buttonBorderHighlight} !important;
    background-color: ${({ theme }) => theme.name === "light-theme" ? theme.colors.buttonHover : "rgba(52, 195, 255, 0.1)"};
  }
  
  &.all-filters {
    background-color: ${({ theme }) => theme.colors.lightButton} !important;
    color: ${({ theme }) => theme.colors.white} !important;
    border-radius: 8px !important;
    border: none !important;
    
    &:hover {
      background-color: ${({ theme }) => theme.colors.sidebarLightHover} !important;
      border: none !important;
      box-shadow: 0 4px 12px rgba(161, 0, 255, 0.3);
    }
  }

  &:disabled {
    opacity: 0.6;
    color: ${({ theme }) => theme.colors.textDisabledColor};
  }
  
  svg {
    color: ${({ theme }) => theme.colors.iconColor};
  }
`;
